import script from "./MarketingSubscribeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketingSubscribeModal.vue?vue&type=script&setup=true&lang=js"

import "./MarketingSubscribeModal.vue?vue&type=style&index=0&id=05461da0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05461da0"]])

export default __exports__